module.exports = __webpack_public_path__ + "img/46_3.04381081.png";